export const THEME_COLORS = {
  yellow: "#E8C458",
  darkblue: "#52ADC1",
  lightblue: "#6AA4F7",
  green: "#06513D",
  pink: "#EAA89D",
  white: "#FFFFFF",
  bgcolorbutton: "#E6EEEC",
};
